import { useEffect, useRef } from "react";
import { Form } from "react-bootstrap";

export default function PinCodeBoxes({ value, onChange, length = 4, disabled = false, autoFocus = false, onEnter }) {
	const refs = useRef([]);
	const digits = (value || "").padEnd(length, " ").slice(0, length).split("");

	function focusIndex(index) {
		if (refs.current[index]) {
			refs.current[index].focus();
			refs.current[index].select();
		}
	}

	function setDigit(index, nextChar) {
		const raw = (value || "").padEnd(length, " ").split("");
		raw[index] = nextChar;
		onChange(raw.join("").replace(/\s/g, ""));
	}

	function handleChange(index, nextValue) {
		const cleaned = (nextValue || "").replace(/\D/g, "");
		if (cleaned.length === 0) {
			setDigit(index, "");
			return;
		}

		setDigit(index, cleaned[cleaned.length - 1]);
		if (index < length - 1) {
			focusIndex(index + 1);
		}
	}

	function handleKeyDown(index, event) {
		if (event.key === "Backspace" && !digits[index]?.trim() && index > 0) {
			setDigit(index - 1, "");
			focusIndex(index - 1);
			event.preventDefault();
			return;
		}

		if (event.key === "Enter" && index === length - 1 && !disabled && (value || "").length === length) {
			event.preventDefault();
			onEnter?.();
		}
	}

	useEffect(() => {
		if (!autoFocus || disabled) {
			return;
		}

		const input = refs.current[0];
		if (input) {
			input.focus();
			input.select();
		}
	}, [autoFocus, disabled]);

	return (
		<div className="d-flex justify-content-center" style={{ gap: "12px" }}>
			{digits.map((digit, index) => (
				<Form.Control
					key={index}
					ref={(el) => {
						refs.current[index] = el;
					}}
					type="text"
					inputMode="numeric"
					autoComplete="one-time-code"
					maxLength={1}
					disabled={disabled}
					value={digit.trim()}
					onChange={(event) => handleChange(index, event.target.value)}
					onKeyDown={(event) => handleKeyDown(index, event)}
					className="text-center fw-bold"
					style={{
						width: "58px",
						height: "58px",
						fontSize: "1.4rem",
						backgroundColor: "#FFFFFF",
						borderColor: "#DEE2E6",
						borderRadius: "10px",
					}}
				/>
			))}
		</div>
	);
}
